import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import { NotificationManager } from 'react-notifications';
import {
   contractRenewalList,
   fetchContractRenewal,
   deleteContractRenewal,
   agreementAllDetails,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';


class students extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         adddiv: false,
         vdiv: false,
         editdiv: false,
         student: '',
         studentid:'',
         agreeid:'',
         expirydate:'',
         installment:[],
         totalamount:'',
         miscellexpense:'',
         selecttype:'',
         notes:'',
         status:'',
         eid:'',
         duedate_1:'',
         duedate_2:'',
         duedate_3:'',
         duedate_4:'',
         frtax_1:'',
         frtax_2:'',
         frtax_3:'',
         frtax_4:'',
         frfees_1:'',
         frfees_2:'',
         frfees_3:'',
         frfees_4:'',       

      };


      this.onBackSection = this.onBackSection.bind(this);
      this.deleteForm = this.deleteForm.bind(this);
      this.onAddSession1 = this.onAddSession1.bind(this);
   }

   UNSAFE_componentWillMount() {
      this.props.contractRenewalList();
   }


   onAddSession() {
      this.setState({
         viewdiv: false,
         editdiv: false,
         adddiv: true,
         vdiv: false,
      });
   }

   onBackSection() {
      this.setState({
         adddiv: false,
         viewdiv: true,
         editdiv: false,
         vdiv: false,

      });
   }


   onAddSession1(craID) {
      this.props.agreementAllDetails();
      this.props.fetchContractRenewal(craID).then((data) => {
         const details = data.data;
         const renewal = details.renewal[0];
            this.setState({
               eid:renewal.craID,
               student: renewal.studentname,
               studentid:renewal.cra_studentID,
               agreeid: renewal.cra_agreement_id,
               expirydate:renewal.cra_expirydate,
               installment:details.feelist,
               totalamount:renewal.cra_totalamount,
               miscellexpense:renewal.cra_miscellexpense,
               notes:renewal.cra_additionalnotes,
               status:renewal.cra_status,
               selecttype:renewal.cra_program,
               viewdiv: false,
               adddiv: false,
               editdiv: true
            })
         
      });
   }

   deleteForm(data) {
      this.data = data;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {
      if (popupResponse) {
         this.props.deleteContractRenewal(this.data.craID);
         this.data = "";
      }
   }

   render() {
      const { match, contractrenewallist, loading } = this.props;
      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         responsive:'standard',
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };

      const columns = [
         { name: "no", label: "NO" },
         { name: "studentname", label: "Student Name" },
         { name: "entrydate", label: "Entry Date" },
         { name: "totalamount", label: "Total Amount" },
         { name: "status", label: "Status" },
         { name: "action", label: "Edit" },
         { name: "action1", label: "Delete" },
      ];

      const tabledata = (contractrenewallist || []).map((assmntval, idx) => {
         const ebtn = (            
            <IconButton className="text-info" aria-label="edit" onClick={() => this.onAddSession1(assmntval.craID)}><EditOutlinedIcon/></IconButton>
         );
         const dbtn = (
            <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteForm(assmntval)}><DeleteOutlineOutlinedIcon/></IconButton>
         );
         
         let restatus = null;
         if (assmntval.cra_status === 1) {
            restatus = <span style={{ color:"#505971",padding:"5px",background:"#b4f3b4",fontWeight:"bold" }}>Parent Accepted</span>;
         } else if (assmntval.cra_status === 2) {
            restatus = <span style={{ color:"#505971",padding:"5px",background:"#f4433691",fontWeight:"bold" }}>Parent Declined</span>;
         } else if (assmntval.cra_status === 3) {
            restatus = <span style={{ color:"#505971",padding:"5px",background:"#4aedd5",fontWeight:"bold" }}>Change Program</span>;
         }

         return {
            no: idx + 1,
            studentname: assmntval.studentname,
            entrydate: assmntval.entrydate,
            totalamount: assmntval.cra_totalamount,
            status:restatus,
            action: ebtn,
            action1: dbtn,
         };
      });
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title> Contract Renewal List | {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.contractrenewal" />} match={match} />

            {this.state.viewdiv &&
               <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>
                  <RctCollapsibleCard heading="List" fullBlock>
                     <MUIDataTable
                        title={<div><Button onClick={() => this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add </Button></div>}
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            }
            {this.state.adddiv &&
               <AddItem onClick={this.onBackSection} />
            }

            {this.state.editdiv &&
               <UpdateItems onClick={this.onBackSection} data={this.state} />
            }
         

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'renewal'}
            />

         </div>
      )
   }
}

const mapStateToProps = ({ contractrenewal }) => {
   const { contractrenewallist, loading } = contractrenewal;
   return { contractrenewallist, loading };
}

export default connect(mapStateToProps, {
   contractRenewalList,
   fetchContractRenewal,
   deleteContractRenewal,
   agreementAllDetails,
})(students); 